
export default class SaveMemberModel {
    memberId: string = "";
    memberNumber: string = "";

    static from(json: string): SaveMemberModel {
        let model = Object.assign(new SaveMemberModel(), json);
        return model;
    }
}